// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsOutlinedSvg from "@ant-design/icons-svg/es/asn/ContactsOutlined";
import AntdIcon from '../components/AntdIcon';

var ContactsOutlined = function ContactsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsOutlinedSvg
  }));
};

ContactsOutlined.displayName = 'ContactsOutlined';
export default /*#__PURE__*/React.forwardRef(ContactsOutlined);